import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const INITIAL_STATE = {
    searchedPlace: {
        latitude: null,
        longitude: null,
        value: null,
    },
};
export const reducer = createReducer(INITIAL_STATE, (builder) => {
    builder.addCase(actions.searchedPlace, (state, { payload }) => ({
        ...state,
        searchedPlace: payload,
    }));
});
